import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_24 = { class: "ui-card ui-mt-30" }
const _hoisted_25 = { class: "ui-card-header" }
const _hoisted_26 = { class: "ui-card-header-content" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Áreas de Entrega")
  ])
], -1)
const _hoisted_28 = { class: "ui-card-header-content-button" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Nova área")
], -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "ui-card-body" }
const _hoisted_32 = { class: "ui-table" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ui-row header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-15 ui-cell ui-cell-editable" }, " Região/Estado/Cidade "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-cell-editable" }, " CEP Inicial "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-cell-editable" }, " CEP Final "),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable ui-align-center" })
], -1)
const _hoisted_34 = { class: "ui-rows" }
const _hoisted_35 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-15 ui-cell ui-cell-editable",
  "data-title": "Região/Estado/Cidade"
}
const _hoisted_36 = ["onChange", "onUpdate:modelValue"]
const _hoisted_37 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-cell-editable",
  "data-title": "CEP Inicial"
}
const _hoisted_38 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ui-cell ui-cell-editable",
  "data-title": "CEP Final"
}
const _hoisted_39 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-1 ui-cell ui-cell-editable",
  "data-title": "Ações"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "ui-button-content" }
const _hoisted_42 = { class: "ui-card ui-mt-30" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Formas de Entregas")
      ])
    ])
  ])
], -1)
const _hoisted_44 = { class: "ui-card-body" }
const _hoisted_45 = { class: "ant-row" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_47 = { class: "ui-card ui-mt-30" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ui-card-header-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ui-header-content-title" }, [
      /*#__PURE__*/_createElementVNode("h4", { class: "ui-card-title" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Aplicação da Regra")
      ])
    ])
  ])
], -1)
const _hoisted_49 = { class: "ui-card-body" }
const _hoisted_50 = { class: "ant-row" }
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_caixa_selecao = _resolveComponent("caixa-selecao")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_icone = _resolveComponent("icone")!
  const _component_combo_forma_entrega = _resolveComponent("combo-forma-entrega")!
  const _component_combo_aplicacao_regra_frete = _resolveComponent("combo-aplicacao-regra-frete")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Tipo da Regra")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_caixa_selecao, {
                      opcoes: _ctx.state.opcoesCaixaSelacao,
                      valor: _ctx.state.regraFrete.tipo,
                      "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.regraFrete.tipo) = $event)),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.verificarAlteracaoTipo($event)))
                    }, null, 8, ["opcoes", "valor"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Nome" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.regraFrete.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.regraFrete.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.regraFrete.status,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.regraFrete.status) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Inativa")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ativa")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, { label: "Data Ínicio" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          "data-selecionada": _ctx.state.regraFrete.dataInicio,
                          "onUpdate:dataSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.regraFrete.dataInicio) = $event))
                        }, null, 8, ["data-selecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, { label: "Data Fim" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          "data-selecionada": _ctx.state.regraFrete.dataFim,
                          "onUpdate:dataSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.regraFrete.dataFim) = $event))
                        }, null, 8, ["data-selecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, { label: "Valor mínimo da Compra" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          monetario: true,
                          valor: _ctx.state.regraFrete.valorMinimoCompra,
                          "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.regraFrete.valorMinimoCompra) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Descrição")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.regraFrete.descricao,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.regraFrete.descricao) = $event))
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      class: "ui-button -primary ui-mh-32 ui-full",
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.novaAreaEntrega()))
                    }, _hoisted_30)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.regraFrete.areas, (area, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(area.removida?'ui-d-none':'ant-row ui-row ui-row-editable')
                      }, [
                        _createElementVNode("div", _hoisted_35, [
                          _withDirectives(_createElementVNode("input", {
                            onChange: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": ($event: any) => ((area.regiaoEstadoCidade) = $event)
                          }, null, 40, _hoisted_36), [
                            [_vModelText, area.regiaoEstadoCidade]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_campo_cep, {
                            onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                            valor: area.cepInicial,
                            "onUpdate:valor": ($event: any) => ((area.cepInicial) = $event)
                          }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_campo_cep, {
                            onValorDigitado: ($event: any) => (_ctx.areaEntregaAlterada(index)),
                            valor: area.cepFinal,
                            "onUpdate:valor": ($event: any) => ((area.cepFinal) = $event)
                          }, null, 8, ["onValorDigitado", "valor", "onUpdate:valor"])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("button", {
                            class: "ui-button ui-mh-32 ui-full",
                            type: "button",
                            onClick: ($event: any) => (_ctx.removerAreaEntrega(index))
                          }, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ])
                            ])
                          ], 8, _hoisted_40)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ], 512), [
                  [_vShow, (_ctx.state.regraFrete.areas.length > 0)]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_combo_forma_entrega, {
                      multiplaSelecao: true,
                      codigos: _ctx.state.formasEntregasSelecionadas,
                      "onUpdate:codigos": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.formasEntregasSelecionadas) = $event))
                    }, null, 8, ["codigos"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_a_form_item, { label: "Escolha um opção" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_aplicacao_regra_frete, {
                          tipo: _ctx.state.regraFrete.tipo,
                          valor: _ctx.state.regraFrete.aplicacao,
                          "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.regraFrete.aplicacao) = $event))
                        }, null, 8, ["tipo", "valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    ((_ctx.state.regraFrete.tipo === _ctx.ETipoRegraFrete.Preco || _ctx.state.regraFrete.tipo === _ctx.ETipoRegraFrete.Impostos))
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 0,
                          label: "Valor"
                        }, {
                          default: _withCtx(() => [
                            ((_ctx.state.regraFrete.aplicacao === _ctx.EAplicacaoRegraFrete.AcrescimoValor || _ctx.state.regraFrete.aplicacao === _ctx.EAplicacaoRegraFrete.DescontoValor || _ctx.state.regraFrete.aplicacao === _ctx.EAplicacaoRegraFrete.ValorFixo))
                              ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                  key: 0,
                                  monetario: true,
                                  valor: _ctx.state.regraFrete.valor,
                                  "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.regraFrete.valor) = $event))
                                }, null, 8, ["valor"]))
                              : ((_ctx.state.regraFrete.aplicacao === _ctx.EAplicacaoRegraFrete.AcrescimoPercentual || _ctx.state.regraFrete.aplicacao === _ctx.EAplicacaoRegraFrete.DescontoPercentual))
                                ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                    key: 1,
                                    percentual: true,
                                    valor: _ctx.state.regraFrete.valor,
                                    "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.regraFrete.valor) = $event))
                                  }, null, 8, ["valor"]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 1,
                          label: "Prazo/Dias"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "ant-input ui-ta-right",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.regraFrete.prazo) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.regraFrete.prazo]
                            ])
                          ]),
                          _: 1
                        }))
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}